// Static mapping of friendly names to FI codes
const FIGroups = {
    'Deposit': ['DEPOSIT'],
    'Term Deposit': ['TERM-DEPOSIT', 'TERM_DEPOSIT'],
    'Recurring Deposit': ['RECURRING_DEPOSIT', 'RECURRING-DEPOSIT'],
    'Insurance': ['INSURANCE_POLICIES'],
    'General Insurance': ['GENERAL_INSURANCE'],
    'Life Insurance': ['LIFE_INSURANCE'],
    'Mutual Funds': ['MUTUAL_FUNDS'],
    'Equities': ['EQUITIES'],
    'GSTIN': ['GSTR1_3B'],
    'NPS': ['NPS'],
    'ETF': ['ETF'],
    'REIT': ['REIT'],
    'INVIT': ['INVIT'],
    'IDR': ['IDR'],
    'CIS': ['CIS'],
    'AIF': ['AIF'],
    'SIP': ['SIP'],
};

// Create reverse lookup (case-insensitive & ignoring _ / -)
const FIGroupLookup = Object.entries(FIGroups).reduce((acc, [group, codes]) => {
    codes.forEach(code => {
        const normalized = code.toLowerCase().replace(/[-_]/g, '');
        acc[normalized] = group;
    });
    return acc;
}, {});

// Format function for any FI type
const formatFIType = (value) => {
    if (!value) return '';
    const normalized = value.toLowerCase().replace(/[-_]/g, '');
    if (FIGroupLookup[normalized]) {
        return FIGroupLookup[normalized];
    }
    // Fallback: auto-format unknown codes
    return value
        .replace(/[-_]/g, ' ')       // replace - and _ with spaces
        .replace(/\b\w/g, c => c.toUpperCase()); // capitalize each word
};

export { FIGroups, FIGroupLookup, formatFIType };
